import { Repeat2, PenSquare } from 'lucide-react'
import { useEffect, useRef } from 'react'

interface RepostDropdownProps {
  isOpen: boolean
  onClose: () => void
  onRepost: () => void
  onQuote: () => void
  isReposted: boolean
  anchorRef?: React.RefObject<HTMLElement>
}

export default function RepostDropdown({
  isOpen,
  onClose,
  onRepost,
  onQuote,
  isReposted,
  anchorRef,
}: RepostDropdownProps) {
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      ref={dropdownRef}
      className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden z-50 min-w-[200px]"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={() => { onRepost(); onClose() }}
        className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left"
      >
        <Repeat2 className={`w-5 h-5 ${isReposted ? 'text-green-500' : 'text-gray-600'}`} />
        <span className={`text-sm font-medium ${isReposted ? 'text-green-500' : 'text-gray-900'}`}>
          {isReposted ? 'Undo Repost' : 'Repost'}
        </span>
      </button>
      <button
        onClick={() => { onQuote(); onClose() }}
        className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left border-t border-gray-100"
      >
        <PenSquare className="w-5 h-5 text-gray-600" />
        <span className="text-sm font-medium text-gray-900">Quote</span>
      </button>
    </div>
  )
}
